/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the DataExportDownloadUrlResponse interface.
 */
export function instanceOfDataExportDownloadUrlResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function DataExportDownloadUrlResponseFromJSON(json) {
    return DataExportDownloadUrlResponseFromJSONTyped(json, false);
}
export function DataExportDownloadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': !exists(json, 'url') ? undefined : json['url'],
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
    };
}
export function DataExportDownloadUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
    };
}
